export const foodAmountAfterItemDiscount = ({ amount, item_discount }) =>
  Math.round((Number(amount) - Number(item_discount || 0)) * 100) / 100;
